module.exports = __webpack_public_path__ + "static/media/S (168).d31fc1c4.jpg";